/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// External component
import {
  Autocomplete,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
// Graphql
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_ACTIVITIES_BY_CRITERIA } from "../../graphql";
import { GET_ACTIVITIES_BY_ID_MH } from "../../graphql/activity/activity.query";
// SCSS
import "./ActivityCodeSelect.scss";

function CustomOption(props, option) {
  return (
    <Stack {...props}>
      <Typography typography="modeColor" variant="body1" width="100%">
        <b>{option?.code}</b>
      </Typography>
      <Typography typography="modeColor" variant="body2" width="100%">
        {option.label}
      </Typography>
    </Stack>
  );
}

function ActivityCodeSelect({
  handleChange,
  sx,
  optional,
  defaultCode,
  disabled,
}) {
  const { data: activities } = useQuery(GET_ACTIVITIES_BY_ID_MH, {
    variables: { id_MH: defaultCode },
    skip: !defaultCode,
  });

  const [inputValue, setInputValue] = useState(activities?.activity?.Name);
  const [options, setOptions] = useState([]);

  const [getActivities, { data, loading: queryLoading }] = useLazyQuery(
    GET_ACTIVITIES_BY_CRITERIA,
  );

  useEffect(() => {
    if (!inputValue) return;

    getActivities({ variables: { criteria: inputValue } });
  }, [inputValue, getActivities]);

  useEffect(() => {
    if (!data?.activities) return;

    const result = data.activities.map(item => ({
      code: item?.id_MH,
      label: item?.Name,
      value: item?.id,
    }));
    setOptions(result);
  }, [data, defaultCode]);

  return (
    <Autocomplete
      disabled={disabled}
      filterOptions={x => x}
      options={options}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: queryLoading ? (
              <CircularProgress color="inherit" size={20} />
            ) : null,
          }}
          label={
            activities?.activity?.Name ||
            (optional ? "Actividad económica" : "Actividad económica opcional")
          }
          sx={{
            "borderRadius": 1,
            "& .MuiInputBase-root": {
              height: "48px",
            },
            "& .MuiFilledInput-root": {
              paddingTop: 1.8,
              paddingBottom: 0,
            },
            "& .MuiInputBase-input": {
              padding: "10px 12px",
            },
            ...sx,
          }}
          variant="filled"
        />
      )}
      renderOption={(props, option) => CustomOption(props, option)}
      value={inputValue}
      onChange={(event, value) => {
        if (disabled) return;
        setInputValue(value?.label);
        handleChange(value);
      }}
      onInputChange={(event, value) => !disabled && setInputValue(value)}
    />
  );
}

ActivityCodeSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  optional: PropTypes.bool,
  defaultCode: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};
ActivityCodeSelect.defaultProps = {
  optional: false,
  disabled: false,
  sx: {},
};

export default ActivityCodeSelect;
